import React from 'react';
import { IllustrationProps } from '../../../../../types/Common';
import useToggleIllustrationColors from '../../hooks/useToggleIllustrationColors';

const IllustrationCommodities: React.FC<
  React.PropsWithChildren<IllustrationProps>
> = ({ isActive = true, ...otherProps }) => {
  const colors = useToggleIllustrationColors(isActive);
  return (
    <svg
      width={356}
      height={228}
      viewBox="0 0 356 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <mask
        id="mask0_3952_10310"
        style={{ maskType: 'alpha' }}
        width="356"
        height="229"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#C0C2C9" d="M0 .998h356v228H0v-228z"></path>
      </mask>
      <g mask="url(#mask0_3952_10310)">
        <path
          fill={colors.primary[50]}
          d="M337 161.998c0 88.366-71.634 160-160 160s-160-71.634-160-160c0-88.365 71.634-160 160-160s160 71.634 160 160z"
        ></path>
        <rect
          width="15.472"
          height="169.809"
          x="178.902"
          y="58.278"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="7.736"
          transform="rotate(45 178.902 58.278)"
        ></rect>
        <path
          fill={colors.primary[100]}
          fillRule="evenodd"
          d="M150.339 99.304l3.523 3.523a8 8 0 0011.314 0l2.248-2.248c11.881 13.215 19.568 24.5 28.684 41.497 2.012 3.75 7.37 2.322 6.844-1.901-3.743-30.01-15.694-50.95-28.902-64.582l.003-.002a93.42 93.42 0 00-.824-.833c-.319-.322-.64-.64-.961-.952l-.003.003c-13.631-13.208-34.572-25.16-64.582-28.902-4.222-.526-5.65 4.832-1.9 6.844 16.996 9.116 28.281 16.803 41.496 28.684l-2.247 2.248a8 8 0 000 11.314l5.307 5.307z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[500]}
          d="M150.339 99.304l1.415-1.414a2.001 2.001 0 00-2.829 0l1.414 1.414zm17.085 1.275l1.487-1.337a2 2 0 00-2.902-.077l1.415 1.414zm28.684 41.497l-1.762.945 1.762-.945zm6.844-1.901l1.984-.248-1.984.248zM174.05 75.593l-1.414-1.414a1.998 1.998 0 00-.022 2.806l1.436-1.391zm.003-.002l1.414 1.414a2 2 0 00.017-2.81l-1.431 1.396zm-.824-.833l-1.418 1.41.005.005 1.413-1.415zm-.961-.952l1.397-1.432a2 2 0 00-2.811.018l1.414 1.414zm-.003.003l-1.392 1.436a2 2 0 002.806-.022l-1.414-1.414zm-64.582-28.902l-.247 1.985.247-1.985zm-1.9 6.844l.945-1.763-.945 1.763zm41.496 28.684l1.415 1.415a2.003 2.003 0 00-.077-2.902l-1.338 1.487zm-2.247 13.562l1.414-1.415-1.414 1.415zm5.307 5.307l-1.414 1.414a2 2 0 002.828 0l-1.414-1.414zm4.937 2.108l-3.522-3.522-2.829 2.828 3.523 3.523 2.828-2.829zm8.486 0a6 6 0 01-8.486 0l-2.828 2.829c3.905 3.905 10.237 3.905 14.142 0l-2.828-2.829zm2.247-2.247l-2.247 2.247 2.828 2.829 2.248-2.248-2.829-2.828zm31.862 41.966c-9.181-17.117-16.957-28.538-28.96-41.89l-2.975 2.675c11.759 13.079 19.357 24.228 28.41 41.105l3.525-1.89zm3.096-.708c.076.608-.066.99-.228 1.225a1.374 1.374 0 01-.784.538c-.65.177-1.531-.023-2.084-1.055l-3.525 1.89c1.457 2.718 4.262 3.678 6.662 3.024 2.445-.667 4.32-2.978 3.928-6.118l-3.969.496zm-28.353-63.438c12.903 13.317 24.664 33.855 28.353 63.438l3.969-.496c-3.796-30.437-15.937-51.78-29.45-65.725l-2.872 2.783zm2.85.023l.003-.003-2.829-2.829-.002.003 2.828 2.829zm.02-2.814a97.42 97.42 0 00-.841-.852l-2.827 2.83c.272.272.54.543.805.815l2.863-2.793zm-4.612 1.043c.313.306.627.617.939.931l2.836-2.82a85.567 85.567 0 00-.982-.974l-2.793 2.864zm2.807-.014l.003-.003-2.828-2.828-.003.003 2.828 2.828zm-.022-2.85c-13.945-13.513-35.289-25.654-65.726-29.45l-.495 3.969c29.582 3.69 50.121 15.45 63.437 28.353l2.784-2.872zm-65.726-29.45c-3.14-.392-5.45 1.483-6.117 3.928-.655 2.4.305 5.205 3.023 6.662l1.891-3.525c-1.032-.553-1.232-1.434-1.055-2.084.093-.34.286-.612.537-.784.235-.162.618-.304 1.226-.228l.495-3.97zm-3.094 10.59c16.878 9.053 28.026 16.651 41.105 28.41l2.675-2.975c-13.352-12.003-24.773-19.78-41.889-28.96l-1.891 3.525zm41.028 25.508l-2.247 2.248 2.828 2.828 2.248-2.247-2.829-2.829zm-2.247 2.248c-3.906 3.905-3.906 10.237 0 14.142l2.828-2.829a6 6 0 010-8.485l-2.828-2.828zm0 14.142l5.307 5.307 2.828-2.828-5.307-5.308-2.828 2.829zm8.135 5.307h.001l-2.829-2.828 2.828 2.828z"
        ></path>
        <path
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M139.409 190.896L117.5 248H205l-18.513-55.997c-7.375-22.308-38.661-23.044-47.078-1.107z"
        ></path>
        <path
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M198.929 164.999L163 262h138l-36.485-97.15c-11.392-30.333-54.332-30.235-65.586.149z"
        ></path>
        <path
          fill={colors.primary[500]}
          fillRule="evenodd"
          d="M20 226.998a2 2 0 012-2h310a2 2 0 110 4H22a2 2 0 01-2-2z"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  );
};

export default IllustrationCommodities;
